import { useBlock } from '../../services/entities/hooks/useBlock';
import { useStages } from '../../services/entities/hooks/useStages';
import { useGetScanByIdQuery } from '../../services/entities/impl/blfApi/endpoints/scans';
import { Block } from '../../services/entities/impl/blfApi/schemas/block';
import { Scan } from '../../services/entities/impl/blfApi/schemas/scan';
import { useLoadBlockStageMap } from './BlockPointsMap/hooks/useLoadBlockStageMap';

export const useBlockDetails = (
  id: Block['id'] | undefined,
  scanId: Scan['id'] | undefined
): { block: Block | null; scan: Scan | null; loading: boolean } => {
  const { block, isBlockLoading } = useBlock(id);
  const {
    data: scan,
    isLoading: isScanLoading,
    isFetching: isScanFetching,
  } = useGetScanByIdQuery(scanId);

  const { stages, isStagesLoading } = useStages(block?.varietyID);

  const { loading: isLoadingBlockStageMap } = useLoadBlockStageMap(
    scan?.customerID,
    id,
    scan?.scanDate,
    stages,
    isBlockLoading || isScanLoading || isScanFetching || isStagesLoading
  );

  const loading =
    isBlockLoading ||
    isScanLoading ||
    isScanFetching ||
    isStagesLoading ||
    isLoadingBlockStageMap;

  return {
    block: block ?? null,
    scan: scan ?? null,
    loading: loading,
  };
};
